import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-resourceadjustmentedit',
  templateUrl: './resourceadjustmentedit.component.html',
  styleUrls: ['./resourceadjustmentedit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResourceadjustmenteditComponent {

}
